import { render, staticRenderFns } from "./DocumnetList.vue?vue&type=template&id=0750d7bc&scoped=true"
import script from "./DocumnetList.vue?vue&type=script&lang=js"
export * from "./DocumnetList.vue?vue&type=script&lang=js"
import style0 from "./DocumnetList.vue?vue&type=style&index=0&id=0750d7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0750d7bc",
  null
  
)

export default component.exports